import { render, staticRenderFns } from "./SectorManageSave.vue?vue&type=template&id=675fdde3&scoped=true"
import script from "./SectorManageSave.vue?vue&type=script&lang=js"
export * from "./SectorManageSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675fdde3",
  null
  
)

export default component.exports